'use strict';

var React = require('react');

var SvgReportsMajor = function SvgReportsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 5a1 1 0 0 0-.293-.707l-4-4a1.002 1.002 0 0 0-.707-.293h-9.5a1.5 1.5 0 0 0-1.5 1.5v4.5a1 1 0 1 0 2 0v-4h8.586l3.414 3.414v12.586h-12v-1a1 1 0 1 0-2 0v1.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6a1 1 0 0 0 0 2h3v3a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 13-.768.64a1 1 0 0 0 1.475.067l-.707-.707zm-2.5-3 .768-.64a1 1 0 0 0-1.52-.018l.752.658zm-4.253 3.341a1 1 0 0 0 1.506 1.318l-1.506-1.319zm11.046-6.048-5 5 1.414 1.414 5-5-1.414-1.414zm-3.525 5.067-2.5-3-1.536 1.28 2.5 3 1.536-1.28zm-4.02-3.018-3.5 4 1.505 1.316 3.5-4-1.506-1.316z"
  }));
};

exports.SvgReportsMajor = SvgReportsMajor;
